import AccordionRender from "./AccordionRenderTypesObjects.jsx";
import useGet from "hooks/useFetch.js";

const CheckListsObjectsElements = ({
  typeEventsTypeElements,
  handleChangeCheckObjects,
}) => {
  const [poinLibraryObjects] = useGet("api/v1/point-libraries");
  const [pointTypeObjects] = useGet("api/v1/type-elements");

  const res =
    pointTypeObjects &&
    !pointTypeObjects.error &&
    pointTypeObjects.map((elm) => {
      return elm.pointLibraryId;
    });

  const idTypes =
    res &&
    !res.error &&
    res.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
  return (
    <div
      style={{
        marginBottom: "20px",
        width: "100%",
      }}
    >
      {poinLibraryObjects &&
        !poinLibraryObjects.error &&
        poinLibraryObjects.map((library, key) =>
          idTypes && !idTypes.error && idTypes.includes(library.id) ? (
            <AccordionRender
              handleChangeCheckObjects={handleChangeCheckObjects}
              typeEventsTypeElements={typeEventsTypeElements}
              key={key}
              library={library}
            />
          ) : (
            <></>
          )
        )}
    </div>
  );
};

export default CheckListsObjectsElements;
